import * as ARMdl from '../models/BillToModel';
import * as ServiceMasterMdl from '../models/ServiceMasterModel';
import * as ARInvoiceMdl from '../models/ArInvoiceModel';

export interface SessionModel {
    SelectedAR: ARMdl.BillToModel;
    SelectedSM: ServiceMasterMdl.ServiceMaster;
    TransactionFeeEnabled: boolean;
    TransactionFeePerc: number;
    TransactionFeeLabel: string;
    CheckSalesAmtMin: boolean;
    SalesAmountLowerCeiling: number;     
}

export const initialState: SessionModel = {
    SelectedAR: { ...ARMdl.initialState },
    SelectedSM: { ...ServiceMasterMdl.initialState },
     TransactionFeeEnabled: false,
    TransactionFeePerc:0,
    TransactionFeeLabel: '',
    CheckSalesAmtMin: false,
    SalesAmountLowerCeiling: 0
};

